import cFilter from './cFilter.vue';

export default {
  install(Vue) {
    Vue.component('cFilter', cFilter);
  },
};
